<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <path d="M21.4632 5.74203H19.5433H19.3033H17.8874L17.5034 4.80465C17.2394 4.15741 16.5674 3.73334 15.8235 3.73334H12.4157C11.6717 3.73334 10.9998 4.15741 10.7358 4.80465L10.3518 5.74203H8.7199H8.47991H6.56002C6.03205 5.74203 5.60007 6.1884 5.60007 6.67941V23.3739C5.60007 23.8649 6.03205 24.2667 6.56002 24.2667H21.4392C21.9671 24.2667 22.3991 23.8649 22.3991 23.3739V6.67941C22.4231 6.1884 21.9911 5.74203 21.4632 5.74203ZM11.0478 7.52754C11.4557 7.52754 11.8157 7.30435 11.9597 6.96957L12.5357 5.51884H15.7515L16.3275 6.96957C16.4714 7.32667 16.8314 7.52754 17.2394 7.52754H18.0074L17.3114 8.7997C17.1914 8.97825 16.9754 9.08986 16.7354 9.08986H11.5277C11.3117 9.08986 11.0958 9.00059 10.9758 8.82204L10.1838 7.52754H11.0478ZM20.5032 22.4812H7.54396V7.52754H7.95192L9.29587 9.75942C9.29587 9.78174 9.31986 9.75945 9.31986 9.78176C9.79983 10.4736 10.6158 10.8754 11.5037 10.8754H16.7114C17.6234 10.8754 18.4873 10.4513 18.9433 9.69246C18.9433 9.67014 18.9673 9.64783 18.9673 9.64783L20.1192 7.52754H20.4792V22.4812H20.5032Z" fill="#00527F"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "closedSidebarLogo"
  }
</script>

<style scoped>

</style>
